import { RequirementAttachmentResponse } from "lib-klab-sdks";
import { RequirementAttachment } from "../../../domain/models/requirement/requirement-attachment.model";

export function mapRequirementAttachment(source: RequirementAttachmentResponse): RequirementAttachment {
  const { requirementAttachmentId, ...fields } = source;
  return { id: requirementAttachmentId, ...fields };
}
